module.exports = __webpack_public_path__ + "static/progress-5fe56e0dfd4182df33b801b397bb48bb.png";